import { AnimatePresence, motion } from "framer-motion"
import _ from "lodash"
import { createRef, useContext, useEffect, useRef, useState } from "react"
import { GlobalStateContext } from "../GlobalState"
import BackBtn from "./BackBtn"
import { Row } from "./Layout"
import css from "./ScreenshotGallery.module.scss"

const ScreenshotGallery = ({ app, images }) => {
  const { setShouldScroll } = useContext(GlobalStateContext)
  const [selectedImage, setSelectedImage] = useState()
  const imageRefs = _.fromPairs(images.map(k => [k, createRef()]))
  const [previewImageRefs] = useState(
    _.fromPairs(images.map(k => [k, createRef()]))
  )
  const previewImageWrapperRef = useRef()
  const [shouldObserveImages, setShouldObserveImages] = useState(true)

  // Scroll to selected image
  useEffect(() => {
    if (selectedImage) {
      imageRefs[selectedImage].current.scrollIntoView({
        behavior: "instant",
        block: "center",
      })
    }
  }, [selectedImage, imageRefs])

  useEffect(() => {
    setShouldObserveImages(false)
    _.each(previewImageRefs, img => {
      new ResizeObserver((event, observer) => {
        if (!img.current) return
        if (img.current.naturalWidth > 0) {
          observer.disconnect()
          previewImageWrapperRef.current.scrollLeft = 0
        }
      }).observe(img.current)
    })
  }, [
    previewImageWrapperRef,
    _.every(previewImageRefs, img => img.current),
    shouldObserveImages,
  ])

  // Handle back button - close gallery if it's open
  useEffect(() => {
    setShouldScroll(!selectedImage) // disable scroll when gallery is open

    function handlePopState(e) {
      if (selectedImage) {
        window.history.forward()
        closeGallery()
      }
    }

    window.addEventListener("popstate", handlePopState)

    return () => {
      window.removeEventListener("popstate", handlePopState)
    }
  }, [selectedImage, setShouldScroll])

  function openGallery(img) {
    setSelectedImage(img)
  }

  function closeGallery() {
    setSelectedImage(null)
  }

  return (
    <>
      <Row
        className={css.screenshotGallery}
        padding="0 1.5rem lg"
        gap={14}
        ref={previewImageWrapperRef}
      >
        {images.map((img, i) => (
          <img
            className={css.img}
            key={i}
            src={img}
            alt=""
            referrerPolicy="no-referrer"
            onClick={() => openGallery(img)}
            ref={previewImageRefs[img]}
          />
        ))}
      </Row>

      <AnimatePresence>
        {selectedImage && (
          <motion.div
            className={css.fullScreenshotGallery}
            initial={{ opacity: 0, scale: 0.95, filter: "blur(10px)" }}
            animate={{ opacity: 1, scale: 1, filter: "blur(0px)" }}
            exit={{ opacity: 0, scale: 0.95, filter: "blur(10px)" }}
          >
            <BackBtn className={css.backBtn} onClick={closeGallery} />

            <Row className={css.images} padding="md" gap={18} col={1}>
              {images.map((img, i) => (
                <img
                  key={i}
                  alt={i}
                  className={css.img}
                  src={img}
                  ref={imageRefs[img]}
                />
              ))}
            </Row>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  )
}

export default ScreenshotGallery
